import { SqliteRevisionedRepository } from "./sqlite-revisioned-repository.js";
export class SqliteAgentRepository extends SqliteRevisionedRepository {
    constructor(database, options = {}) {
        super(database, { ...options, domain: "agent" });
    }
}
//# sourceMappingURL=agent-repository.js.map